import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ContactModal from './ContactModal';
import { useModal } from '../context/ModalContext';

const Layout = ({ children }) => {
    const { isContactModalOpen, closeContactModal } = useModal();

    return (
        <div className="min-h-screen bg-[#fafbfc] flex flex-col">
            <Navbar />
            <main className="flex-grow">
                {children}
            </main>
            <Footer />
            <ContactModal
                isOpen={isContactModalOpen}
                onClose={closeContactModal}
            />
        </div>
    );
};

export default Layout;
